import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { Select, MenuItem, InputLabel } from '@material-ui/core';

import "moment/locale/pt-br"
import styles from './styles.module.scss'
import Paginacao from '../../../components/Paginacao'
import Voltar from '../../../components/VoltarBtn/voltar'
import { getParceiros, getRegional, getFilial, adminstradorAtivarInativar, perfis, saveAdmin, getAdmin, aproveAdmin, listarParceirosGerente } from '../../../services/api-auto';
import ParceiroCard from '../../../components/ParceiroCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons'

import { useDispatch } from "react-redux"
import {
    showMsgW as showMsgWAction,
    showMsgE as showMsgEAction,
    showMsgS as showMsgSAction,
} from '../../../store/actions/snackbarActions.js';
import { useDebounce } from '../../../hooks/debounceHook'
import ModalLoading from '../../../components/ModalLoading'
import service from '../../../services'
import PasswordStrength from '../../../components/PasswordStrength'
import services from '../../../services';

const dataInit = {
    userId: "",
    nomeCompleto: "",
    cpf: "",
    email: "",
    phoneNumber: "",
    cargo: "",
    perfilAcesso: "",
    senha: "",
    confirmarSenha: "",
    status: "",
    usuarioAprovador: "",
    listaAddPdvGenRelacio: [],
    listaRemovePdvGenRelacio: []
}

const cargoInit = {
    roleId: '',
    displayName: ''
}


const Detalhes = () => {
    const dispatch = useDispatch();
    const showMsgW = (msg) => dispatch(showMsgWAction(msg));
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));
    const showMsgS = (msg) => dispatch(showMsgSAction(msg));

    const [data, setData] = useState(dataInit);
    const [regional, setRegional] = useState([]);

    const [regionalSelecionado, setRegionalSelecionado] = useState('todos');
    const [filial, setFilial] = useState([]);
    const [filialSelecionado, setFilialSelecionado] = useState('todos');
    const [parceiros, setParceiros] = useState([]);
    const [parceiroSelecionado, setParceiroSelecionado] = useState('todos');
    const [perfisList, setPerfisList] = useState([]);

    const history = useHistory()


    const [buscar, setBuscar] = useState('');
    const [nomeParceiroSelecionado, setNomeParceiroSelecionado] = useState('todos');
    const [parceiroAcaoPresentes, setParceiroAcaoPresentes] = useState([])
    const [indicarErros, setIndicarErros] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);
    const [permiteAdicionarAlterar, setPermiteAlterar] = useState(services.storage.getClaimValues("Administradores", "Adicionar") || services.storage.getClaimValues("Administradores", "Alterar"));

    const validarForm = () => {
        let valid = true
        let msg = ""

        if (!data.nomeCompleto) {
            let msg = `Campo nome obrigatório`;
            valid = false;
            showMsgW(msg)
        }
        if (!data.cpf) {
            msg = "Campo CPF é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }
        if (!data.email) {
            msg = "Campo E-mail é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }
        if (!data.phoneNumber) {
            msg = "Campo Celular é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }
        if (!data.cargo) {
            msg = "Campo cargo é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }
        if (data.perfilAcesso == null) {
            msg = "Campo perfil é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }
        if (!data.userId && !data.senha) {
            msg = "Campo Confirmar Senha é obrigatórios\n";
            valid = false;
            showMsgW(msg)
        }
        if (data.senha && !data.confirmarSenha) {
            msg = "Campo Confirmar Senha é obrigatórios\n";
            valid = false;
            showMsgW(msg)
        }

        return valid
    }

    const status = new URLSearchParams(history.location.search).get("status")
    const encerrar = async () => {
        setModalLoading(true)
   
        await adminstradorAtivarInativar(data.userId)
        setModalLoading(false)
        history.push('/administradores')
    }

    const getCampanhaIfEdit = async (id) => {
        if (id) {
            setModalLoading(true)
            try {
                const info = await getAdmin(id);
                info.data.listaAddPdvGenRelacio = [];
                info.data.listaRemovePdvGenRelacio = [];

                setData(info.data);
                pesquisar(info.data.userId);
            } catch (e) {
                showMsgW('Não foi possível carregar os dados')
            } finally {
                setModalLoading(false)
            }
        }
    }

    const carregarRegional = async () => {
        const info = await getRegional()
        setRegional(info);
    }

    const carregarFilial = async () => {
        setModalLoading(true)
        try {
            const info = await getFilial(regionalSelecionado)
            setFilial(info);
        } catch (e) {
            showMsgE("Ocorreu um erro ao carregar os Filiais")
        } finally {
            setModalLoading(false)
        }
    }

    const carregarParceiro = async () => {
        setModalLoading(true)
        try {
            const info = await getParceiros(regionalSelecionado, filialSelecionado)
            setParceiros(info);
        } catch (e) {
            showMsgE("Ocorreu um erro ao carregar os Parceiros")
        } finally {
            setModalLoading(false)
        }
    }

    const createSenderForm = () => {
        let formdata = {};

        if (data.userId !== '') { formdata.userId = data.userId; }

        formdata.nomeCompleto = data.nomeCompleto
        formdata.email = data.email
        formdata.phoneNumber = service.mask.unMask(data.phoneNumber)
        formdata.cargo = data.cargo
        formdata.usuarioAprovador = data.usuarioAprovador
        formdata.perfilAcesso = data.perfilAcesso
        formdata.cpf = service.mask.unMask(data.cpf)
        formdata.senha = data.senha
        formdata.confirmaSenha = data.confirmarSenha
        formdata.listaAddPdvGenRelacio = data.listaAddPdvGenRelacio
        formdata.listaRemovePdvGenRelacio = data.listaRemovePdvGenRelacio

        return formdata;
    }

    const enviar = async () => {
        setIndicarErros(false)
        if (validarForm()) {
            let formdata = createSenderForm()
            setModalLoading(true)
            try {
                await saveAdmin(formdata);

                showMsgS("Dados salvos com sucesso!")
                setTimeout(() => {
                    history.push('/administradores')
                }, 2000)
            } catch (erro) {
                showMsgE(erro.response.data.message);
            }
            setModalLoading(false)
        }
    }

    const pesquisar = async (userId, q) => {
        const info = await listarParceirosGerente(page, userId, q)
        setParceiroAcaoPresentes(info.items);
        setMaxPage(info.totalPages);
    }

    const loadPerfil = async () => {
        const info = await perfis()
        setPerfisList(info.data)
    }

    const handlerPerfil = (e) => {
        const newData = { ...data, perfilAcesso: e.target.value }
        if (e.target.value !== 0) {
            newData.usuarioAprovador = false
        }

        setData(newData)
    }

    useEffect(() => {
        carregarRegional();
        const adm = new URLSearchParams(history.location.search).get("usuario")
        getCampanhaIfEdit(adm)
        loadPerfil()
    }, [])

    useEffect(() => {
        if (regionalSelecionado) {
            carregarFilial();
        }
    }, [regionalSelecionado])

    useEffect(() => {
        if (filialSelecionado) {
            carregarParceiro();
        }
    }, [filialSelecionado])

    useEffect(() => {
        if (data.userId) {
            pesquisar(data.userId, buscar);
        }
    }, [page])

    const handlerAprovador = (event) => {
        //if (data.perfilAcesso === 0) {
        setData({ ...data, usuarioAprovador: event.target.checked })
        //} else {
        //    setData({ ...data, usuarioAprovador: false })
        // }
    }
    const aprovar = async () => {
        setModalLoading(true)
        let response = await aproveAdmin(data.userId)
        setModalLoading(false)
        if (response.fail)
            showMsgW(response.errors.message)
        else
            history.push('/administradores')
    }

    function removerParceiroExistente(parceiro, i) {
        var novoData = {
            ...data,
            listaAddPdvGenRelacio: [
                ...data.listaAddPdvGenRelacio,
                parceiro
            ]
        };

        setData(novoData);

        var novoParceiroAcaoPresentes = [...parceiroAcaoPresentes];
        novoParceiroAcaoPresentes.splice(i, 1);
        setParceiroAcaoPresentes(novoParceiroAcaoPresentes);
    }

    // controle da lista de lojas cadastradas a remover
    function voltarParceiroExistente(parceiro, i) {
        var novoData = { ...data };
        novoData.listaAddPdvGenRelacio.splice(i, 1);
        setData(novoData);

        var novoParceiroAcaoPresentes = [...parceiroAcaoPresentes, parceiro];
        setParceiroAcaoPresentes(novoParceiroAcaoPresentes);
    }

    function adicionarParceiroNovo() {
        if (!regionalSelecionado || regionalSelecionado === "todos") {
            showMsgW('Selecione uma regional')
            return;
        }

        if ([3, 4].includes(data.perfilAcesso) && (!filialSelecionado || filialSelecionado === "todos")) {
            showMsgW('Selecione uma filial')
            return;
        }

        if ([4].includes(data.perfilAcesso) && (!parceiroSelecionado || parceiroSelecionado === "todos")) {
            showMsgW('Selecione uma loja')
            return;
        }

        var item = {};
        item.regional = regionalSelecionado;

        if ([3, 4].includes(data.perfilAcesso))
            item.filial = filialSelecionado;

        if ([4].includes(data.perfilAcesso)) {
            item.nomeParceiro = nomeParceiroSelecionado;
            item.idParceiro = parceiroSelecionado;
        }

        setData({
            ...data,
            listaAddPdvGenRelacio: [
                ...data.listaAddPdvGenRelacio,
                item
            ]
        });
    }

    function removerParceiroNovo(parceiro, i) {
        var novoData = { ...data };
        novoData.listaAddPdvGenRelacio.splice(i, 1);

        setData(novoData);
    }

    // controle da lista de lojas cadastradas
    function removerParceiroExistente(parceiro, i) {
        var novoData = {
            ...data,
            listaRemovePdvGenRelacio: [
                ...data.listaRemovePdvGenRelacio,
                parceiro
            ]
        };

        setData(novoData);

        var novoParceiroAcaoPresentes = [...parceiroAcaoPresentes];
        novoParceiroAcaoPresentes.splice(i, 1);
        setParceiroAcaoPresentes(novoParceiroAcaoPresentes);
    }

    // controle da lista de lojas cadastradas a remover
    function voltarParceiroExistente(parceiro, i) {
        var novoData = { ...data };
        novoData.listaRemovePdvGenRelacio.splice(i, 1);
        setData(novoData);

        var novoParceiroAcaoPresentes = [...parceiroAcaoPresentes, parceiro];
        setParceiroAcaoPresentes(novoParceiroAcaoPresentes);
    }


    return (
        <>
            <div className={styles.wrapper}>
                <div className={styles.title}>
                    Administrador
                    <Voltar />
                </div>
                <div className={styles.blueBackground}>
                    <div className={styles.content}>
                        <div className={styles.card}>
                            <div className={styles.subtitle}>
                                Dados pessoais
                            </div>
                            <FormControl className={styles.half}>
                                <TextField type="text" size="small"
                                    onChange={(e) => { setData({ ...data, nomeCompleto: e.target.value }) }}
                                    label="Nome completo"
                                    inputVariant="outlined"
                                    value={data.nomeCompleto}
                                    variant="filled"
                                    //error={indicarErros && !data.nome ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAdicionarAlterar}
                                />
                            </FormControl>
                            <FormControl className={styles.quarter}>

                                <TextField type="text" size="small"
                                    onChange={(e) => { setData({ ...data, cpf: e.target.value }) }}
                                    label="CPF"
                                    value={service.mask.cpf(data.cpf)}
                                    variant="filled"
                                    error={indicarErros && !data.cpf ? true : false}
                                    className="customFilledInput"
                                    disabled={data.userId}
                                />
                            </FormControl>
                            <FormControl className={styles.quarter}>
                                <TextField type="text" size="small"
                                    onChange={(e) => { setData({ ...data, email: e.target.value }) }}
                                    label="E-mail"
                                    value={data.email}
                                    variant="filled"
                                    error={indicarErros && !data.email ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAdicionarAlterar}
                                />
                            </FormControl>
                            <FormControl className={styles.quarter}>
                                <TextField type="text"
                                    onChange={(e) => { setData({ ...data, phoneNumber: service.mask.celphone(e.target.value) }) }}
                                    label="Celular"
                                    value={service.mask.celphone(data.phoneNumber)}
                                    variant="filled"
                                    error={indicarErros && !data.phoneNumber ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAdicionarAlterar}
                                />
                            </FormControl>
                            <FormControl className={styles.quarter}>
                                <InputLabel id="select-tipo-label" className={styles.label}>
                                    Cargo
                                </InputLabel>
                                <Select
                                    labelId='select-tipo-label'
                                    label="Cargo"
                                    onChange={(e) => { setData({ ...data, cargo: e.target.value }) }}
                                    value={data.cargo}
                                    variant='filled'
                                    className="customFilledInput"
                                    disabled={!permiteAdicionarAlterar}
                                >
                                    {
                                        perfisList.map((item) => {
                                            return (
                                                <MenuItem value={item.displayName} key={item.roleId}>
                                                    {item.displayName}
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <div className={styles.subtitle}>
                                Configurações de acesso
                            </div>
                            <FormControl className={styles.half}>
                                <InputLabel id="select-tipo-label" className={styles.label}>
                                    Perfil de acesso
                                </InputLabel>
                                <Select
                                    labelId='select-tipo-label'
                                    label="perfil"
                                    onChange={(e) => { handlerPerfil(e) }}
                                    value={data.perfilAcesso}
                                    variant='filled'
                                    className="customFilledInput"
                                    disabled={!permiteAdicionarAlterar}
                                >
                                    <MenuItem value={1}>Master</MenuItem>
                                    <MenuItem value={2}>Superintendente</MenuItem>
                                    <MenuItem value={3}>Gerente Filial</MenuItem>
                                    <MenuItem value={4}>Gerente Relacionamento</MenuItem>
                                    <MenuItem value={7}>Call Center</MenuItem>
                                </Select>
                            </FormControl>
                            {
                                (data.perfilAcesso === 1) && (
                                    <div className={`${styles.half} ${styles.centerCheckbox}`}>
                                        <input
                                            className={styles.check}
                                            type='checkbox'
                                            checked={data.usuarioAprovador}
                                            onChange={(event) => { handlerAprovador(event) }}
                                            labelId='aprovador-label'
                                        />

                                        Aprovador
                                    </div>
                                )
                            }

                            <div className='col-sm-12'>
                                <FormControl  >
                                    <TextField label="Senha" type="password" size="small"
                                        onChange={event => { setData({ ...data, senha: event.target.value }) }}
                                        value={data.senha}
                                        variant="filled"
                                        className="customFilledInput"
                                        disabled={!permiteAdicionarAlterar}
                                    />
                                </FormControl>
                            </div>

                            <PasswordStrength password={data.senha} />

                            <div className='col-sm-12'>
                                <FormControl>
                                    <TextField label="Confirme sua senha" type="password" size="small"
                                        onChange={event => { setData({ ...data, confirmarSenha: event.target.value }) }}
                                        value={data.confirmarSenha}
                                        variant="filled"
                                        className="customFilledInput"
                                        disabled={!permiteAdicionarAlterar}
                                    />
                                </FormControl>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    (data.perfilAcesso !== 0 && data.perfilAcesso !== '' && data.perfilAcesso !== 1) && (
                        <div className={styles.blueBackground}>
                            <div className={styles.content}>
                                <div className={styles.card}>
                                    <div className={styles.subtitle}>
                                        {(data.perfilAcesso === 4) && 'Lojas'}
                                        {(data.perfilAcesso === 3) && 'Filiais'}
                                        {(data.perfilAcesso === 2) && 'Regionais'}
                                    </div>
                                    {
                                        permiteAdicionarAlterar && (
                                            <>
                                                <FormControl className={styles.selects} disabled={!permiteAdicionarAlterar}>
                                                    <InputLabel id="select-status-label" className={styles.selectsLabel}>
                                                        Regional
                                                    </InputLabel>
                                                    <Select
                                                        labelId='select-status-label'
                                                        label="Status"
                                                        onChange={(e) => { setRegionalSelecionado(e.target.value) }}
                                                        value={regionalSelecionado}
                                                        variant="filled"
                                                        className="customFilledInput"
                                                    >
                                                        <MenuItem value="todos">Todos</MenuItem>
                                                        {regional.map((regiao) => {
                                                            return (
                                                                <MenuItem value={regiao} key={regiao}>{regiao}</MenuItem>
                                                            )
                                                        })}
                                                    </Select>
                                                </FormControl>
                                                <FormControl className={styles.selects} disabled={!permiteAdicionarAlterar}>
                                                    <InputLabel id="select-status-label" className={styles.selectsLabel}>
                                                        Filial
                                                    </InputLabel>
                                                    <Select
                                                        labelId='select-status-label'
                                                        label="Status"
                                                        onChange={(e) => { setFilialSelecionado(e.target.value) }}
                                                        value={filialSelecionado}
                                                        variant="filled"
                                                        className="customFilledInput"
                                                    >
                                                        <MenuItem value="todos">Todos</MenuItem>
                                                        {filial.map((info) => {
                                                            return (
                                                                <MenuItem value={info} key={info}>{info}</MenuItem>
                                                            )
                                                        })}
                                                    </Select>
                                                </FormControl>
                                                <FormControl className={styles.selects} disabled={!permiteAdicionarAlterar}>
                                                    <InputLabel id="select-status-label" className={styles.selectsLabel}>
                                                        Loja
                                                    </InputLabel>
                                                    <Select
                                                        labelId='select-status-label'
                                                        label="Status"
                                                        onChange={(e) => {
                                                            if (e.target.value !== "todos") {
                                                                setParceiroSelecionado(e.target.value)
                                                                let parceiro = parceiros.find((p) => p.idParceiro === e.target.value)
                                                                setNomeParceiroSelecionado(parceiro.nomeParceiro)
                                                            } else {
                                                                setParceiroSelecionado(e.target.value)
                                                                setNomeParceiroSelecionado(e.target.value)
                                                            }
                                                        }}
                                                        value={parceiroSelecionado}
                                                        variant="filled"
                                                        className="customFilledInput"
                                                    >
                                                        <MenuItem value="todos">Todos</MenuItem>
                                                        {parceiros.map((parceiro) => {
                                                            return (
                                                                <MenuItem value={parceiro.idParceiro} key={parceiro.idParceiro}>
                                                                    {parceiro.nomeParceiro}
                                                                </MenuItem>
                                                            )
                                                        })}
                                                    </Select>
                                                </FormControl>
                                                <button className={styles.salvar} onClick={adicionarParceiroNovo}>
                                                    Adicionar
                                                </button>
                                                <div className={styles.subtitleConfiguracao}>
                                                    {(data.perfilAcesso === 4) && 'Lojas - adicionar'}
                                                    {(data.perfilAcesso === 3) && 'Filiais - adicionar'}
                                                    {(data.perfilAcesso === 2) && 'Regionais - adicionar'}
                                                </div>
                                                <div className={styles.addLojasWrapper}>
                                                    {
                                                        Boolean(data.listaAddPdvGenRelacio.length) ?
                                                            data.listaAddPdvGenRelacio.map((loja, i) => {
                                                                return (
                                                                    <ParceiroCard
                                                                        parceiro={loja}
                                                                        key={loja.idParceiro}
                                                                        remover={() => removerParceiroNovo(loja, i)} />
                                                                )
                                                            }) :
                                                            (
                                                                <div>
                                                                    Nenhum parceiro nesta lista
                                                                </div>
                                                            )
                                                    }
                                                </div>
                                            </>
                                        )

                                    }
                                    {
                                        data.userId && (
                                            <>
                                                <div className={styles.subtitleConfiguracao}>
                                                    {(data.perfilAcesso === 4) && 'Lojas - cadastradas'}
                                                    {(data.perfilAcesso === 3) && 'Filiais - cadastradas'}
                                                    {(data.perfilAcesso === 2) && 'Regionais - cadastradas'}
                                                </div>
                                                {
                                                    Boolean(parceiroAcaoPresentes.length) ?
                                                        <div className={styles.searchWrapper}>
                                                            <TextField
                                                                type="text"
                                                                size="small"
                                                                onChange={(e) => { setBuscar(e.target.value) }}
                                                                label="Faça sua busca"
                                                                value={buscar}
                                                                variant="filled"
                                                                multiline
                                                                className="customFilledInput"
                                                                onKeyDown={
                                                                    (e) => {
                                                                        if (e.key === 'Enter') {
                                                                            pesquisar(data.userId, buscar);
                                                                            e.preventDefault();
                                                                        }
                                                                    }
                                                                }
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <button onClick={() => pesquisar(data.userId, buscar)} className={styles.searchButton}>
                                                                            <FontAwesomeIcon icon={faSearch} />
                                                                        </button>
                                                                    )
                                                                }}
                                                            />
                                                        </div>
                                                        :
                                                        ""
                                                }

                                                <div className={styles.addLojasWrapper}>
                                                    {
                                                        Boolean(parceiroAcaoPresentes.length) ?
                                                            parceiroAcaoPresentes.map((loja, i) => {
                                                                return (
                                                                    <ParceiroCard
                                                                        parceiro={loja}
                                                                        key={loja.idParceiro}
                                                                        permiteAdicionarAlterarResponsavel={permiteAdicionarAlterar}
                                                                        remover={() => removerParceiroExistente(loja, i)} />
                                                                )
                                                            }) :
                                                            (
                                                                <div>
                                                                    Nenhum parceiro nesta lista
                                                                </div>
                                                            )
                                                    }
                                                </div>
                                                {maxPage > 1 && (
                                                    <Paginacao maxPage={maxPage} page={page} setPage={setPage} />
                                                )}
                                                {
                                                    permiteAdicionarAlterar && (
                                                        <>
                                                            <div className={styles.subtitleConfiguracao}>
                                                                {(data.perfilAcesso === 4) && 'Lojas - remover'}
                                                                {(data.perfilAcesso === 3) && 'Filiais - remover'}
                                                                {(data.perfilAcesso === 2) && 'Regionais - remover'}
                                                            </div>
                                                            <div className={styles.addLojasWrapper}>
                                                                {
                                                                    Boolean(data.listaRemovePdvGenRelacio.length) ?
                                                                        data?.listaRemovePdvGenRelacio?.map((loja, i) => {
                                                                            return (
                                                                                <ParceiroCard parceiro={loja} key={loja.idParceiro} remover={() => voltarParceiroExistente(loja, i)} />
                                                                            )
                                                                        }) :
                                                                        (
                                                                            <div>
                                                                                Nenhum parceiro nesta lista
                                                                            </div>
                                                                        )
                                                                }
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    )
                }
                {
                    permiteAdicionarAlterar && (
                        <div className={styles.blueBackground}>
                            <div className={styles.content}>
                                <div className={styles.card}>
                                    <div className={styles.subtitle}>
                                        Ações
                                    </div>
                                    {(data.userId && status === 'Aguardando') ? (
                                        <button className={styles.ativar} onClick={aprovar}>
                                            Aprovar
                                        </button>
                                    ) : null}
                                    {(data.userId && status !== 'Inativo') ? (
                                        <button className={styles.encerrar} onClick={encerrar}>
                                            Inativar
                                        </button>
                                    ) : null}
                                    {(data.userId && status === 'Inativo') ? (
                                        <button className={styles.ativar} onClick={encerrar}>
                                            Ativar
                                        </button>
                                    ) : null}
                                    <button className={styles.salvar} onClick={enviar}>
                                        Salvar
                                    </button>
                                </div>
                            </div>
                        </div>
                    )
                }


            </div>
            <ModalLoading
                open={modalLoading}
                size="lg"
            />

        </>
    );
}

export default Detalhes;